import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { isWeiXin, GetQueryString, ToLogin } from '../utils/utils'
import Cookies from 'js-cookie'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((recode) => recode.meta.noAuth)) {
    next()
  } else {
    if (isWeiXin()) {
      // 是否在微信打开
      const token = Cookies.get('token')
      let code = GetQueryString('code')
      if (token) {
        let isRead = Cookies.get('isRead')
        console.log(isRead)
        if (isRead == 'true') {
          next()
        } else if (to.path.startsWith('/rulePage')) {
          next()
        } else {
          next({
            path: '/rulePage',
            query: {
              toPath: window.location.href,
            },
          })
        }
      } else if (code) {
        let data = await $api.getLoginAuth(code)
        console.log('是否授权页data', data)
        if (data) {
          console.log('设置cookie', data.isRead, data, 'end')
          window.localStorage.setItem('userInfo', JSON.stringify(data))
          Cookies.set('token', data.token, { expires: 1 })
          Cookies.set('isRead', data.isRead, { expires: 1 })
          console.log('设置了token', data.token)
          let url = window.localStorage.getItem('toUrl')
          window.localStorage.removeItem('toUrl')
          window.location.href = url
        }
      } else {
        ToLogin()
      }
    } else {
      next({
        path: '/error',
        query: {
          errorMsg: '请在微信打开该链接',
        },
      })
    }
  }
  // next()
  // console.log(to.path)
})

export default router
